function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.965 13.41v2.216H2.025V13.41c0-.182-.15-.33-.337-.33H.448a.334.334 0 0 0-.337.33v3.76c0 .182.151.33.337.33h15.094a.334.334 0 0 0 .337-.33v-3.76c0-.182-.15-.33-.337-.33h-1.24a.333.333 0 0 0-.337.33z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.237 13.477l4.534-4.44a.334.334 0 0 0 0-.467l-1.075-1.054a.342.342 0 0 0-.477 0L9.171 9.522V.84c0-.182-.151-.33-.337-.33h-1.67a.334.334 0 0 0-.336.33v8.684L4.779 7.517a.342.342 0 0 0-.476 0L3.227 8.57a.327.327 0 0 0 0 .467l4.534 4.44a.34.34 0 0 0 .476 0z"
}));

const SvgIcDownload = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcDownload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-download.e9d49fbd.svg";
export { ForwardRef as ReactComponent };